import {gql} from "@apollo/client";

export const GET_RANDOM_LENDING_ARCH = gql`
    query {
        person {
            firstName
            lastName
            email
            phone
            phone2
            creditScore
            creditProfile
        }
        property {
            value
            type
            used
            location {
                state
                city
                zip
                street
            }
            loan {
                purpose
                program
                currentMortgageBalance
            }
        }
    }
`;